'use strict';

exports.__esModule = true;
exports.presetLoader = presetLoader;

var _default = require('./default.json');

var _default2 = _interopRequireDefault(_default);

var _mobile = require('./mobile.json');

var _mobile2 = _interopRequireDefault(_mobile);

var _presetsTypes = require('./presets-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function presetLoader(presetType) {
  switch (presetType) {
    case _presetsTypes.presetsTypes.DEFAULT:
      return _default2.default;
    case _presetsTypes.presetsTypes.PUBLIC:
      return _default2.default;
    case _presetsTypes.presetsTypes.MOBILE:
      return _mobile2.default;
    default:
      return _default2.default;
  }
}